import React from 'react';

function HomeTradeUp(props: object) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.275 3.55167L4.5375 8.80167C3.4125 9.67667 2.5 11.5392 2.5 12.9517V22.2142C2.5 25.1142 4.8625 27.4892 7.7625 27.4892H22.2375C25.1375 27.4892 27.5 25.1142 27.5 22.2267V13.1267C27.5 11.6142 26.4875 9.67667 25.25 8.81417L17.525 3.40167C15.775 2.17667 12.9625 2.23917 11.275 3.55167Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.625 14.375L15.375 19.625L13.375 16.625L9.375 20.625"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.125 14.375H20.625V16.875"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default HomeTradeUp;
